export default "__VITE_ASSET__Dz1RLR9o__"